export const ORIGINAL_SIZES: Record<string, Record<string, [number, number]>> = {
	hatchback: {
		back: [682, 525],
		driver_side: [1277, 466],
		front: [753, 493],
		passenger_side: [1277, 465],
		top: [1026, 530],
	},
	saloon: {
		back: [705, 500],
		driver_side: [1200, 383],
		front: [785, 500],
		passenger_side: [1200, 383],
		top: [1068, 500],
	},
	suv: {
		back: [579, 500],
		driver_side: [1160, 442],
		front: [687, 500],
		passenger_side: [1200, 458],
		top: [1014, 500],
	},
};

export const MARKER_SIZE: Record<string, number> = { large: 20, medium: 16, small: 8 };

export const SVG_OVERLAY_REGEXP = /.*\.(\d+)x(\d+)\.svg/;
